/**
 * Token field constants shared by the asset forms.
 *
 * Mirrors src/lambdas/asset/tokenSupply.ts in the backend, which enforces the same rules
 * server-side. The form check exists to give the operator an answer while they are still
 * looking at the field; the backend check exists because a form is not a security boundary.
 */

/** The platform's token decimals. Fewer is allowed; more is rejected. */
export const STANDARD_TOKEN_DECIMALS = 18;
